<template>
  <div class="layout">
    <HeadView class="header"></HeadView>
    <router-view class="main" />
    <FooterView class="footer"></FooterView>
  </div>
</template>

<script>
import HeadView from "./head.vue";
import FooterView from "./footer.vue";
export default {
  name: "Layout",
  components: { HeadView, FooterView },
};
</script>

<style scoped>
.layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.header {
  height: 100px;
}
.footer {
  height: 438px;
}
.main {
  flex: 1;
  margin-top: 100px;
}
@media screen and (max-width: 768px) {
  .header {
    height: 72px;
  }
  .footer {
    height: 107px;
  }
  .main {
    margin-top: 72px;
  }
}
</style>
